import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import HomeLayout from "@/components/home/home-layout";
import LottieLoading from "@/components/lottie/lottie-loading";

const ShareExploration: React.FC = () => {
  const [searchParams] = useSearchParams();
  const startedRef = useRef(false);
  const venue = searchParams.get("v");
  let navigate = useNavigate();

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    handleExploration();
  }, []);

  const handleExploration = async () => {
    if (!venue) return;

    try {
      navigate(`/explore3d/${venue}`);
    } catch (e) {
      navigate("/");
    }
  };

  return (
    <div className="flex flex-1 p-4 items-center justify-center">
      <LottieLoading />
    </div>
  );
};

const ShareExplorePage: React.FC = () => {
  return <HomeLayout children={<ShareExploration />}></HomeLayout>;
};

export default ShareExplorePage;
